import styled from 'styled-components';

import welcomeBonusCrown from '../../../assets/images/landing/welcome-bonus-crown.png';
import { __ } from '../../../i18n/l10n';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import Spacer from '../../shared/components/Spacer';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const Modal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const ModalTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const ModalTitle = styled.div`
  font-size: 1.5rem;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const BulletPoints = styled.div`
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const BulletPoint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const Link = styled.a``;

const WelcomeBonusModalInfo = () => (
  <Modal>
    <ModalTitleContainer>
      <img src={welcomeBonusCrown} />
      <Spacer width={'10px'} />
      <ModalTitle>{__('Welcome bonus')}</ModalTitle>
    </ModalTitleContainer>
    <Spacer height={'10px'} />
    <BulletPoints>
      <BulletPoint>
        <p>{'🚀'}</p>
        <Spacer width={'10px'} />
        <p>{__('Your first bet refunded in cash if it loses')}</p>
      </BulletPoint>
      <BulletPoint>
        <p>{'💰'}</p>
        <Spacer width={'10px'} />
        <p>{__('Up to a limit of €100 or the same amount as your first deposit')}</p>
      </BulletPoint>
      <BulletPoint>
        <p>{'🔥'}</p>
        <Spacer width={'10px'} />
        <p>{__('Withdrawable cash credited to your account directly after the result of the first bet')}</p>
      </BulletPoint>
    </BulletPoints>
    <Spacer height={'10px'} />
    <Link href={'https://www.winamax.fr/offre_bienvenue'}>{__('Terms and Conditions')}</Link>
    <Spacer height={20} />
  </Modal>
);

export default WelcomeBonusModalInfo;
